var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsOfficeBuilding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-office-building-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 16,
    height: 16,
    fill: "#e3e5e6",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M14.05,23.03H12.611V10.986H22.655V23.03H21.216V12.367H14.05ZM11,24.063v1.376H24.266V24.063Zm7.44-1.333h1.434V21.353H18.44Zm-2.868,0h1.434V21.353H15.572Zm4.3-3.957H18.44v1.376h1.434Zm-2.868,0H15.572v1.376h1.434Zm2.868-2.408H18.44v1.376h1.434Zm-2.868,0H15.572v1.376h1.434Zm2.868-2.408H18.44v1.376h1.434Zm-2.868,0H15.572v1.376h1.434Z",
    transform: "translate(-9.697 -9.685)",
    fill: "#0071b9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsOfficeBuilding);
export default __webpack_public_path__ + "static/media/icons-office-building.5480584d.svg";
export { ForwardRef as ReactComponent };